import API from '../api';

export default class AchievementService {
  constructor() {
    this.API = new API();
  }
  getPayments = () => this.API.get('/payment/');

  createPayment = (body) => this.API.post('/payment/createPayment', body);
}
